export default {
  setIpList (state, iplist) {
  	state.iplist = iplist;
  }
};
